import { DEFAULT_LOCALE_ID, LocaleId, StringId, TextDirection } from '@strings';
import { Locale, locales } from '../strings/Locale';
import { localStore } from './LocalStore.svelte';

const orderedLocaleIds = Array.from(locales.keys());
const localeIds = new Set<LocaleId>(orderedLocaleIds);

export class LocaleManager {
  #localeId = localStore('flLocale', systemLocaleId());

  get localeId(): LocaleId {
    return this.#localeId.value;
  }

  set localeId(value: LocaleId) {
    this.#localeId.value = value;
  }

  locale = $derived(Locale.getLocale((this as LocaleManager).localeId));

  textDirection = $derived.by<TextDirection>(() => {
    switch (this.localeId) {
      case LocaleId.ar_SA:
      case LocaleId.he_IL:
        return TextDirection.RTL;
      default:
        return TextDirection.LTR;
    }
  });

  localizedString(id: StringId, placeholders?: Record<string, string>): string {
    return Locale.localizedString(id, this.localeId, placeholders);
  }

  nextLocale() {
    const ids = orderedLocaleIds;
    const index = ids.indexOf(this.localeId);
    this.localeId = ids[(index + 1) % ids.length];
  }

  prevLocale() {
    const ids = orderedLocaleIds;
    const index = ids.indexOf(this.localeId);
    this.localeId = ids[(index + ids.length - 1) % ids.length];
  }
}

function systemLocaleId(): LocaleId {
  const systemLocaleIds = navigator.languages;

  // First check for exact match
  for (const systemLocaleId of systemLocaleIds) {
    if (localeIds.has(systemLocaleId.replace('-', '_') as LocaleId)) {
      return systemLocaleId.replace('-', '_') as LocaleId;
    }
  }

  // Then check for language only match
  for (const systemLocaleId of systemLocaleIds) {
    for (const localeId of localeIds) {
      if (localeId.startsWith(systemLocaleId)) {
        return localeId;
      }
    }
  }

  return DEFAULT_LOCALE_ID;
}

export const localeManager = new LocaleManager();
